import { supabase } from "../../config/supabase";

// Update a challenge submission status
const updateSubmissionStatus = async (submitId,statusName,isRejected = false) => {
    // const statusList = ['submitted','evaluated','completed','rejected'];
    let newStatus = { status:statusName };
    switch (statusName) {
        case 'submitted':
            newStatus = { status: 'evaluated' }
            break;
        case 'evaluated':
            newStatus = { status: 'completed' }
            break;
        default:newStatus = { status: statusName }
            break;
    }

    if(isRejected) newStatus.status = 'rejected';
    
    try {
        const { error } = await supabase.from('challenge_submissions').update(newStatus).eq('submit_id', submitId);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in updating challenge submissions:',err);
        return { error: err };
    }
};

//statuses :-  
//submitted
//evaluated
//completed
//rejected

export { updateSubmissionStatus };